import { computed, ref, watchEffect } from 'vue'
import { useAuth0 } from '@auth0/auth0-vue'
import { defineStore } from 'pinia'

export const useAuthStore = defineStore('auth', () => {
  const {
    user,
    isAuthenticated,
    isLoading,
    getAccessTokenSilently,
    loginWithRedirect,
    logout,
    handleRedirectCallback,
  } = useAuth0()
  const accessToken = ref(null)

  watchEffect(async () => {
    if (!isLoading.value) {
      if (window.location.search.includes('code=') && window.location.search.includes('state=')) {
        try {
          const { appState } = await handleRedirectCallback()

          // Redirect to the saved URL
          if (appState?.target) {
            window.location.href = appState.target
          }
        } catch (error) {
          console.error('Callback error:', error)
        }
      } else {
        try {
          accessToken.value = await getAccessTokenSilently()
        } catch (error) {
          console.error('Failed to get access token:', error)
          loginWithRedirect({
            appState: { target: window.location.pathname },
          })
        }
      }
    }
  })

  const roles = computed(() => {
    if (user.value) {
      return user.value['https://jobsrepublic.nl/roles']
    }
    return []
  })

  const isAdmin = computed(() => {
    return !!roles.value?.find((role) => role === 'jobsrepublic-admin')
  })

  return {
    user: computed(() => user.value),
    accessToken: computed(() => accessToken.value),
    isAuthenticated: computed(() => isAuthenticated.value),
    isAdmin,
    isLoading: computed(() => isLoading.value),
    logout: () => {
      logout({ logoutParams: { returnTo: window.location.origin } })
    },
  }
})
